import { AppState } from '../../../../core/Store';
import { State } from './reducer';

type Selector<T = any> = (redState: State, appState: AppState) => T;
function prepareSelector<T>(selector: Selector<T>) {
	return (state: AppState) => {
		return selector(state.data.dictionaries.risksDict, state);
	};
}

export const getRisksOc = prepareSelector((redState, appState) => {
	return redState.risksOc;
});

export const getRisksKop = prepareSelector((redState, appState) => {
	return redState.risksKop;
});

export const getRisksNnw = prepareSelector((redState, appState) => {
	return redState.risksNnw;
});

export const getRisksNnwKlauzule = prepareSelector((redState, appState) => {
	return redState.risksNnwKlauzule;
});

export const getLoaded = prepareSelector((redState, appState) => {
	return redState.loaded;
});
